import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      position: 'fixed',
      zIndex: 9,
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      background: palette.background.box
    },
    container: {
      height: '100%',
      overflowY: 'scroll',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    menu: {
      display: 'flex',
      flexDirection: 'column',
      gap: '25px',
      paddingTop: '80px',
      marginBottom: '25px',
      width: 'max-content',
      paddingLeft: '30px'
    },
    menuBottom: {
      width: '100%',
      padding: '0 25px 80px 15px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
